(function () {
  const defaultHeaderItems = [
    {
      title: "Free Extras",
      url: "/collections/free-extras",
      type: "collection_link",
      items: []
    },
    {
      title: "Hard Coolers",
      url: "/collections/hard-coolers",
      type: "collection_link",
      items: [
        {
          title: "Shop Hard Coolers",
          url: "/collections/hard-coolers",
          type: "collection_link",
          items: [
            { title: "Ultra-Light Coolers", url: "/collections/ultra-light-coolers", type: "collection_link" },
            { title: "Ultra-Tough Coolers", url: "/collections/ultra-tough-coolers", type: "collection_link" },
            { title: "Wheeled Coolers", url: "/collections/wheeled-coolers", type: "collection_link" }
          ]
        },
        {
          title: "Make It Yours",
          url: "/collections/hard-coolers",
          type: "collection_link",
          items: [
            { title: "Personalize with MyRTIC", url: "/collections/myrtic", type: "collection_link" },
            { title: "Custom Shop", url: "/collections/custom-shop", type: "collection_link" },
            { title: "Shop All", url: "/collections/hard-coolers", type: "collection_link" }
          ]
        }
      ]
    },
    {
      title: "Soft Coolers",
      url: "/collections/soft-coolers",
      type: "collection_link",
      items: [
        {
          title: "Shop Soft Coolers",
          url: "/collections/soft-coolers",
          type: "collection_link",
          items: [
            { title: "Waterproof Coolers", url: "/collections/waterproof-coolers", type: "collection_link" },
            { title: "Backpack Coolers", url: "/collections/backpack-coolers", type: "collection_link" },
            { title: "Day Coolers", url: "/collections/day-coolers", type: "collection_link" },
            { title: "Insulated Bags", url: "/collections/insulated-bags", type: "collection_link" }
          ]
        },
        {
          title: "More Ways to Carry",
          url: "/collections/soft-coolers",
          type: "collection_link",
          items: [
            { title: "Lunch Bags & Boxes", url: "/collections/lunch-bags-and-boxes", type: "collection_link" },
            { title: "Personalize with MyRTIC", url: "/collections/myrtic", type: "collection_link" },
            { title: "Custom Shop", url: "/collections/custom-shop", type: "collection_link" },
            { title: "Shop All", url: "/collections/soft-coolers", type: "collection_link" }
          ]
        }
      ]
    },
    {
      title: "Drinkware",
      url: "/collections/drinkware",
      type: "collection_link",
      items: [
        {
          title: "Shop Drinkware",
          url: "/collections/drinkware",
          type: "collection_link",
          items: [
            { title: "Tumblers & Mugs", url: "/collections/tumblers-and-mugs", type: "collection_link" },
            { title: "Bottles & Jugs", url: "/collections/bottles-and-jugs", type: "collection_link" }
          ]
        },
        {
          title: "Customize & Stock Up",
          url: "/collections/drinkware",
          type: "collection_link",
          items: [
            { title: "Personalize with MyRTIC", url: "/collections/myrtic", type: "collection_link" },
            { title: "Custom Shop", url: "/collections/custom-shop", type: "collection_link" },
            { title: "Shop All", url: "/collections/drinkware", type: "collection_link" }
          ]
        }
      ]
    },
    {
      title: "Bags",
      url: "/collections/bags",
      type: "collection_link",
      items: [
        {
          title: "Shop Bags",
          url: "/collections/bags",
          type: "collection_link",
          items: [
            { title: "Backpacks", url: "/collections/backpacks", type: "collection_link" },
            { title: "Insulated Bags", url: "/collections/insulated-bags", type: "collection_link" }
          ]
        },
        {
          title: "For Everyday Carry",
          url: "/collections/bags",
          type: "collection_link",
          items: [
            { title: "Personalize with MyRTIC", url: "/collections/myrtic", type: "collection_link" },
            { title: "Shop All", url: "/collections/bags", type: "collection_link" }
          ]
        }
      ]
    },
    {
      title: "Shop by Activity",
      url: "/collections/shop-by-activity",
      type: "collection_link",
      items: [
        {
          title: "Shop by Activity",
          url: "/collections/shop-by-activity",
          type: "collection_link",
          items: [
            { title: "Hunting", url: "/collections/hunting", type: "collection_link" },
            { title: "Fishing", url: "/collections/fishing", type: "collection_link" },
            { title: "Travel", url: "/collections/travel", type: "collection_link" },
            { title: "Fitness", url: "/collections/fitness", type: "collection_link" },
            { title: "Tailgating", url: "/collections/tailgating", type: "collection_link" },
            { title: "Snow", url: "/collections/snow", type: "collection_link" }
          ]
        }
      ]
    },
    {
      title: "Custom Shop",
      url: "/collections/custom-shop",
      type: "collection_link",
      items: []
    }
  ];

  const headerFeatureMap = {
    "Hard Coolers": {
      title: "Meet the 52QT Ultra-Light Wheeled Cooler",
      copy: "Take good times on the go with our all-terrain wheeled cooler.",
      image: "/cdn/shop/files/rtic-20260716-theme-414748566-cb06e99ef4066b04.webp",
      href: "/collections/hard-coolers"
    },
    "Soft Coolers": {
      title: "Meet the Ultra-Tough Soft Cooler",
      copy: "A waterproof Soft Cooler designed for fun that floats.",
      image: "/cdn/shop/files/rtic-20260716-theme-109328915-2b7a599cb7cb6807.webp",
      href: "/collections/soft-coolers"
    },
    "Drinkware": {
      title: "NEW Refuel Bottle",
      copy: "Meet the ultimate gym buddy with an easy-chug lid, all-day insulation, and a removable shaker.",
      image: "/cdn/shop/files/rtic-20260716-theme-196322103-75fb9b3f2d709222.webp",
      href: "/collections/drinkware"
    },
    "Bags": {
      title: "Tote-Ally Summer",
      copy: "Discover hot new seasonal looks for our best-selling totes, bags, and backpacks.",
      image: "/cdn/shop/files/rtic-20260716-theme-4151485696-71b55ad19432b200.webp",
      href: "/collections/bags"
    },
    "Shop by Activity": {
      title: "Adventure-ready picks",
      copy: "Browse current RTIC products grouped by how people actually use them.",
      image: "/cdn/shop/files/rtic-20260716-theme-3584926048-6a6fe2ea7a0514f8.jpg",
      href: "/collections/shop-by-activity"
    }
  };

  const categories = [
    ["Hard Coolers", "/cdn/shop/files/rtic-20260716-theme-3963988467-c154c6151b344251.webp", "/collections/hard-coolers"],
    ["Soft Coolers", "/cdn/shop/files/rtic-20260716-theme-1159535853-5e729886f2173fb5.webp", "/collections/soft-coolers"],
    ["Drinkware", "/cdn/shop/files/rtic-20260716-theme-3210159127-10cd2932f7145e0b.webp", "/collections/drinkware"],
    ["Bags", "/cdn/shop/files/rtic-20260716-theme-2022552122-6d90231ae61322a8.webp", "/collections/bags"],
    ["MyRTIC", "/cdn/shop/files/rtic-20260716-theme-1368458372-47a4a09535a6d6c9.webp", "/collections/myrtic"],
    ["Custom Shop", "/cdn/shop/files/rtic-20260716-theme-4017723694-44d9ac2772f66f54.webp", "/collections/custom-shop"]
  ];

  const promoCards = [
    {
      href: "/collections/lunch-bags-and-boxes",
      alt: "Pink insulated lunch bag with a personalized lunch container, patterned RTIC water bottle, and reusable utensils.",
      desktopImage: "/cdn/shop/files/rtic-20260716-theme-3127787348-147d9d47770609fd.webp",
      mobileImage: "/cdn/shop/files/rtic-20260716-theme-3823517273-f8b921e898424790.jpg",
      desktopLogo: "/cdn/shop/files/rtic-20260716-theme-1029435445-682c30e8b8764ebc.svg",
      mobileLogo: "/cdn/shop/files/rtic-20260716-theme-1043706953-0a6893fa9679c05b.svg",
      logoAlt: "Shop Back to School Deals"
    },
    {
      href: "/collections/backpack-coolers",
      alt: "Blue insulated backpack cooler with lunch containers in the front pocket, worn outdoors while handing a snack to a child.",
      desktopImage: "/cdn/shop/files/rtic-20260716-theme-2702005351-be645a757bfd1475.webp",
      mobileImage: "/cdn/shop/files/rtic-20260716-theme-1391980599-7d40a31da06e9a85.jpg",
      desktopLogo: "/cdn/shop/files/rtic-20260716-theme-225919047-e381fbc373ec3a0c.svg",
      mobileLogo: "/cdn/shop/files/rtic-20260716-theme-1104712140-da6e7e5008bffefc.svg",
      logoAlt: "Shop 2-in-1 Chillout Backpack"
    },
    {
      href: "/collections/drinkware",
      alt: "White RTIC insulated can cooler with a personalized name and wave design, holding a beverage by a swimming pool.",
      desktopImage: "/cdn/shop/files/rtic-20260716-theme-4141491671-fe58960e7361c0d0.jpg",
      mobileImage: "/cdn/shop/files/rtic-20260716-theme-1498211545-ad72f3f5f95f11d1.webp",
      desktopLogo: "/cdn/shop/files/rtic-20260716-theme-1898906540-ea7f21dd0676023b.svg",
      mobileLogo: "/cdn/shop/files/rtic-20260716-theme-2183112866-218fc594dbb664d9.svg",
      logoAlt: "Shop New Ultimate Can Cooler Sizes"
    }
  ];

  const activities = [
    ["Hunting", "/cdn/shop/files/rtic-20260716-theme-2277703838-0d37126efd13f369.webp", "/collections/hunting"],
    ["Fishing", "/cdn/shop/files/rtic-20260716-theme-1525311822-6a3de368a157ed62.webp", "/collections/fishing"],
    ["Travel", "/cdn/shop/files/rtic-20260716-theme-4274716594-649401bfa1cd5199.webp", "/collections/travel"],
    ["Fitness", "/cdn/shop/files/rtic-20260716-theme-1313376493-cbc99559a3b20575.webp", "/collections/fitness"],
    ["Tailgating", "/cdn/shop/files/rtic-20260716-theme-3512694370-d1a3caeb560936b3.webp", "/collections/tailgating"],
    ["Snow", "/cdn/shop/files/rtic-20260716-theme-4058449279-b91b889a2d259eaa.webp", "/collections/snow"]
  ];

  function readJsonScript(id) {
    const node = document.getElementById(id);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || "{}");
    } catch {
      return null;
    }
  }

  function getHeaderItems() {
    const data = readJsonScript("RticHeaderMenuData");
    if (Array.isArray(data?.items) && data.items.length) {
      return data.items;
    }
    return defaultHeaderItems;
  }

  function getThemeAssetUrl(filename) {
    const script = document.querySelector('script[src*="rtic-preview.js"]');
    const source = script?.getAttribute("src");
    if (!source) return "";
    try {
      const url = new URL(source, window.location.origin);
      const parts = url.pathname.split("/");
      parts[parts.length - 1] = filename;
      url.pathname = parts.join("/");
      url.search = "";
      return url.toString();
    } catch {
      return "";
    }
  }

  const byId = (id) => document.getElementById(id);

  const iconSvg = {
    search: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="6.75" stroke="currentColor"></circle><path d="M16.2 16.2 20 20" stroke="currentColor" stroke-linecap="round"></path></svg>',
    help: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="8" stroke="currentColor"></circle><path d="M9.85 9.6a2.55 2.55 0 1 1 3.8 2.2c-.97.56-1.5 1.05-1.5 2.05" stroke="currentColor" stroke-linecap="round"></path><circle cx="12" cy="17.1" r=".7" fill="currentColor"></circle></svg>',
    cart: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5.5 6.2h13l-1.3 7.1H8.2L6.8 4H4.3" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><circle cx="10" cy="18" r="1.15" fill="currentColor"></circle><circle cx="16.8" cy="18" r="1.15" fill="currentColor"></circle></svg>',
    menu: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" stroke-linecap="round"></path></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6 18 18M18 6 6 18" stroke="currentColor" stroke-linecap="round"></path></svg>'
  };

  function renderHeader() {
    const nav = byId("rticNav");
    const megaShell = byId("rticMegaShell");
    const drawerNav = byId("rticDrawerNav");
    if (!nav || !megaShell || !drawerNav) return;
    const headerItems = getHeaderItems();
    const megaItems = headerItems.filter((item) => Array.isArray(item.items) && item.items.length);

    nav.innerHTML = headerItems
      .map((item) => {
        if (item.items?.length) {
          return `
            <div class="rtic-nav__group" data-mega-group="${item.title}">
              <a class="rtic-nav__link rtic-nav__link--parent" href="${item.url}" data-mega-trigger="${item.title}" aria-expanded="false">${item.title}</a>
            </div>
          `;
        }
        return `<a class="rtic-nav__link" href="${item.url}">${item.title}</a>`;
      })
      .join("");

    megaShell.innerHTML = `
      <div class="rtic-mega__surface">
        ${megaItems
          .map((item) => {
            const feature = headerFeatureMap[item.title];
            return `
              <section class="rtic-mega__panel${feature ? "" : " rtic-mega__panel--no-feature"}" data-mega-panel="${item.title}">
                ${item.items
                  .map((group) => `
                    <div>
                      ${group.url ? `<a class="rtic-mega__heading rtic-mega__heading-link" href="${group.url}">${group.title}</a>` : `<p class="rtic-mega__heading">${group.title}</p>`}
                      <div class="rtic-mega__list">
                        ${(group.items || []).map((child) => `<a href="${child.url}">${child.title}</a>`).join("")}
                      </div>
                    </div>
                  `)
                  .join("")}
                ${feature ? `
                  <div class="rtic-mega__feature">
                    <a class="rtic-mega__feature-card" href="${feature.href}">
                      <img src="${feature.image}" alt="${feature.title}">
                    </a>
                    <div class="rtic-mega__feature-copy">
                      <div class="rtic-mega__feature-title">${feature.title}</div>
                      <div class="rtic-mega__feature-text">${feature.copy}</div>
                    </div>
                  </div>
                ` : ""}
              </section>
            `;
          })
          .join("")}
      </div>
    `;

    drawerNav.innerHTML = headerItems
      .map((item, index) => {
        if (!item.items?.length) {
          return `<a class="rtic-drawer__link" href="${item.url}">${item.title}</a>`;
        }

        const panelId = `rticDrawerPanel${index}`;

        return `
          <section class="rtic-drawer__item" data-drawer-item>
            <div class="rtic-drawer__row">
              <a class="rtic-drawer__parent-link" href="${item.url}">${item.title}</a>
              <button class="rtic-drawer__toggle" type="button" data-drawer-toggle aria-expanded="false" aria-controls="${panelId}">
                <span class="rtic-sr-only">Toggle ${item.title}</span>
              </button>
            </div>
            <div class="rtic-drawer__panel" id="${panelId}" hidden>
              ${item.items
                .map((group) => {
                  const childLinks = group.items || [];
                  if (!childLinks.length) {
                    return `<a class="rtic-drawer__link" href="${group.url || item.url}">${group.title}</a>`;
                  }
                  return `
                    <div class="rtic-drawer__group">
                      <a class="rtic-drawer__group-heading" href="${group.url || item.url}">${group.title}</a>
                      <div class="rtic-drawer__link-grid">
                        ${childLinks.map((child) => `<a href="${child.url}">${child.title}</a>`).join("")}
                      </div>
                    </div>
                  `;
                })
                .join("")}
            </div>
          </section>
        `;
      })
      .join("");

    const header = byId("rticHeader");
    let closeTimer;

    function closeMega() {
      header.classList.remove("is-mega-open");
      nav.querySelectorAll("[data-mega-trigger]").forEach((button) => button.setAttribute("aria-expanded", "false"));
      megaShell.querySelectorAll("[data-mega-panel]").forEach((panel) => panel.classList.remove("is-active"));
    }

    function openMega(name) {
      clearTimeout(closeTimer);
      header.classList.add("is-mega-open");
      nav.querySelectorAll("[data-mega-trigger]").forEach((button) => {
        button.setAttribute("aria-expanded", String(button.dataset.megaTrigger === name));
      });
      megaShell.querySelectorAll("[data-mega-panel]").forEach((panel) => {
        panel.classList.toggle("is-active", panel.dataset.megaPanel === name);
      });
    }

    nav.querySelectorAll("[data-mega-trigger]").forEach((link) => {
      link.addEventListener("mouseenter", () => openMega(link.dataset.megaTrigger));
      link.addEventListener("focus", () => openMega(link.dataset.megaTrigger));
    });

    nav.querySelectorAll("[data-mega-group]").forEach((group) => {
      group.addEventListener("mouseenter", () => openMega(group.dataset.megaGroup));
    });

    header.addEventListener("mouseleave", () => {
      closeTimer = window.setTimeout(closeMega, 120);
    });

    megaShell.addEventListener("mouseenter", () => clearTimeout(closeTimer));
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeMega();
    });

    drawerNav.querySelectorAll("[data-drawer-toggle]").forEach((toggle) => {
      toggle.addEventListener("click", () => {
        const parent = toggle.closest("[data-drawer-item]");
        const panel = parent?.querySelector(".rtic-drawer__panel");
        if (!parent || !panel) return;
        const nextOpen = !parent.classList.contains("is-open");
        parent.classList.toggle("is-open", nextOpen);
        toggle.setAttribute("aria-expanded", String(nextOpen));
        if (nextOpen) {
          panel.removeAttribute("hidden");
        } else {
          panel.setAttribute("hidden", "");
        }
      });
    });
  }

  function renderCards() {
    const categoryTrack = byId("rticCategoryTrack");
    const promoTrack = byId("rticPromoTrack");
    const activityTrack = byId("rticActivityTrack");

    if (categoryTrack && !categoryTrack.children.length) {
      categoryTrack.innerHTML = categories
        .map(
          ([title, image, href]) => `
            <a class="rtic-carousel__card rtic-category-card" href="${href}">
              <span class="rtic-category-card__media"><img src="${image}" alt="${title}"></span>
              <span class="rtic-category-card__title">${title}</span>
            </a>
          `
        )
        .join("");
    }

    if (promoTrack && !promoTrack.children.length) {
      promoTrack.innerHTML = promoCards
        .map(
          (card) => `
            <a class="rtic-promo-card" href="${card.href}" aria-label="${card.logoAlt}">
              <span class="rtic-promo-card__media">
                <picture>
                  <source media="(min-width: 641px)" srcset="${card.desktopImage}">
                  <img src="${card.mobileImage}" alt="${card.alt}">
                </picture>
              </span>
              <span class="rtic-promo-card__overlay" aria-hidden="true">
                <img class="rtic-promo-card__logo rtic-promo-card__logo--desktop" src="${card.desktopLogo}" alt="">
                <img class="rtic-promo-card__logo rtic-promo-card__logo--mobile" src="${card.mobileLogo}" alt="">
              </span>
            </a>
          `
        )
        .join("");
    }

    if (activityTrack && !activityTrack.children.length) {
      activityTrack.innerHTML = activities
        .map(
          ([title, image, href]) => `
            <a class="rtic-carousel__card rtic-activity-card" href="${href}">
              <span class="rtic-activity-card__media"><img src="${image}" alt="${title}"></span>
              <span class="rtic-activity-card__title">${title}</span>
            </a>
          `
        )
        .join("");
    }
  }

  function initCarousels() {
    document.querySelectorAll("[data-carousel]").forEach((carousel) => {
      const viewport = carousel.querySelector(".rtic-carousel__viewport");
      const track = carousel.querySelector(".rtic-track");
      const dotsWrap = carousel.querySelector(".rtic-carousel__dots");
      const prev = carousel.querySelector("[data-prev]");
      const next = carousel.querySelector("[data-next]");
      if (!viewport || !track || !dotsWrap || !prev || !next) return;

      let pages = [];
      let activeIndex = 0;

      function computePages() {
        const maxLeft = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        const firstCard = track.children[0];
        const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || "16");
        const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : viewport.clientWidth;
        const step = Math.max(cardWidth + gap, viewport.clientWidth * 0.82);
        const values = [0];
        while (values[values.length - 1] < maxLeft - 4) {
          values.push(Math.min(maxLeft, values[values.length - 1] + step));
          if (values.length > 20) break;
        }
        if (!values.length) values.push(0);
        pages = Array.from(new Set(values.map((value) => Math.round(value))));
      }

      function syncControls() {
        if (!pages.length) return;
        const current = viewport.scrollLeft;
        activeIndex = pages.reduce((closest, value, index) => {
          const best = Math.abs(current - pages[closest]);
          const diff = Math.abs(current - value);
          return diff < best ? index : closest;
        }, 0);

        prev.disabled = activeIndex === 0;
        next.disabled = activeIndex === pages.length - 1;

        dotsWrap.querySelectorAll(".rtic-carousel__dot").forEach((dot, index) => {
          dot.classList.toggle("is-active", index === activeIndex);
        });
      }

      function renderDots() {
        dotsWrap.innerHTML = pages
          .map((_, index) => `<button class="rtic-carousel__dot${index === 0 ? " is-active" : ""}" type="button" aria-label="Go to slide ${index + 1}" data-dot="${index}"></button>`)
          .join("");

        dotsWrap.querySelectorAll("[data-dot]").forEach((dot) => {
          dot.addEventListener("click", () => {
            viewport.scrollTo({ left: pages[Number(dot.dataset.dot)] || 0, behavior: "smooth" });
          });
        });

        const isOverflowing = viewport.scrollWidth > viewport.clientWidth + 4;
        carousel.querySelector(".rtic-carousel__footer").style.display = isOverflowing ? "flex" : "none";
      }

      function jump(step) {
        const targetIndex = Math.max(0, Math.min(pages.length - 1, activeIndex + step));
        viewport.scrollTo({ left: pages[targetIndex] || 0, behavior: "smooth" });
      }

      prev.addEventListener("click", () => jump(-1));
      next.addEventListener("click", () => jump(1));
      viewport.addEventListener("scroll", () => window.requestAnimationFrame(syncControls), { passive: true });
      window.addEventListener("resize", () => {
        computePages();
        renderDots();
        syncControls();
      });

      computePages();
      renderDots();
      syncControls();
    });
  }

  function initSearch() {
    const toggle = byId("rticSearchToggle");
    const bar = byId("rticSearchBar");
    const field = byId("rticSearchField");
    if (!toggle || !bar || !field) return;
    toggle.innerHTML = iconSvg.search;
    toggle.addEventListener("click", () => {
      bar.classList.toggle("is-open");
      if (bar.classList.contains("is-open")) field.focus();
    });
  }

  function initIcons() {
    const help = byId("rticHelpIcon");
    const cart = byId("rticCartIcon");
    const menu = byId("rticMenuToggle");
    const drawer = byId("rticDrawer");
    const drawerClose = byId("rticDrawerClose");
    if (help) help.innerHTML = iconSvg.help;
    if (cart) {
      const glyph = cart.querySelector("[data-rtic-cart-glyph]");
      if (glyph) {
        glyph.innerHTML = iconSvg.cart;
      } else {
        const badgeMarkup = cart.querySelector(".rtic-icon-link__badge")?.outerHTML || "";
        cart.innerHTML = `${iconSvg.cart}${badgeMarkup}`;
      }
    }
    if (menu) menu.innerHTML = iconSvg.menu;
    if (drawerClose) drawerClose.innerHTML = iconSvg.close;

    if (menu && drawer && drawerClose) {
      menu.addEventListener("click", () => {
        drawer.classList.add("is-open");
        drawer.removeAttribute("hidden");
      });
      drawerClose.addEventListener("click", () => {
        drawer.classList.remove("is-open");
        drawer.setAttribute("hidden", "");
      });
      drawer.addEventListener("click", (event) => {
        if (event.target === drawer) {
          drawer.classList.remove("is-open");
          drawer.setAttribute("hidden", "");
        }
      });
    }
  }

  function syncLocalLogos() {
    const headerLogoUrl = getThemeAssetUrl("rtic-logo-header.svg");
    const footerLogoUrl = getThemeAssetUrl("rtic-logo-footer.svg");
    const applyLogos = () => {
      if (headerLogoUrl) {
        document.querySelectorAll("#rticHeader .rtic-header__logo img, #rticDrawer .rtic-drawer__top img").forEach((img) => {
          img.setAttribute("src", headerLogoUrl);
        });
      }

      if (footerLogoUrl) {
        document.querySelectorAll("#rticFooter .rtic-footer__logo").forEach((img) => {
          img.setAttribute("src", footerLogoUrl);
        });
      }
    };

    applyLogos();
    window.requestAnimationFrame(applyLogos);
    window.setTimeout(applyLogos, 120);
    window.setTimeout(applyLogos, 500);
    let syncAttempts = 0;
    const syncTimer = window.setInterval(() => {
      applyLogos();
      syncAttempts += 1;
      if (syncAttempts >= 20) {
        window.clearInterval(syncTimer);
      }
    }, 250);
  }

  function initPromoDialog() {
    const dialog = byId("rticPromoDialog");
    const close = byId("rticPromoClose");
    if (!dialog || !close) return;
    close.innerHTML = iconSvg.close;

    function openDialog() {
      if (typeof dialog.showModal === "function") {
        dialog.showModal();
      } else {
        dialog.setAttribute("open", "");
      }
    }

    function closeDialog() {
      if (typeof dialog.close === "function") {
        dialog.close();
      } else {
        dialog.removeAttribute("open");
      }
    }

    close.addEventListener("click", closeDialog);
    dialog.addEventListener("click", (event) => {
      const rect = dialog.getBoundingClientRect();
      const inDialog =
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width;
      if (!inDialog) closeDialog();
    });

    window.requestAnimationFrame(() => {
      if (dialog.hasAttribute("open")) {
        closeDialog();
      }
    });
  }

  function initAutoplayVideos() {
    document.querySelectorAll("video[autoplay]").forEach((video) => {
      const tryPlay = () => {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(() => {});
        }
      };

      if (video.readyState >= 2) {
        tryPlay();
      } else {
        video.addEventListener("loadeddata", tryPlay, { once: true });
      }

      document.addEventListener(
        "visibilitychange",
        () => {
          if (!document.hidden) tryPlay();
        },
        { passive: true }
      );
    });
  }

  function bootRticPreview() {
    renderHeader();
    renderCards();
    initIcons();
    initSearch();
    syncLocalLogos();
    initCarousels();
    initPromoDialog();
    initAutoplayVideos();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootRticPreview, { once: true });
  } else {
    bootRticPreview();
  }

  window.addEventListener("load", syncLocalLogos);
  window.setTimeout(syncLocalLogos, 150);
  window.setTimeout(syncLocalLogos, 800);
})();
